export default __webpack_public_path__ + "static/perfective-future-4bb3844e7b7a7288472e9c39d5c4c3f7.svg";